"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledItem = exports.StyledContainer = exports.StyledBox = exports.setBackgroundColor = exports.setSizing = exports.setBorders = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const box_1 = require("../box");
const setBorders = (props) => {
    const border = props.border;
    const borderBottom = props.borderBottom;
    const borderLeft = props.borderLeft;
    const borderRight = props.borderRight;
    const borderTop = props.borderTop;
    const borderRadius = props.borderRadius;
    return (0, styled_components_1.css) `
    border: ${border};
    border-bottom: ${borderBottom};
    border-left: ${borderLeft};
    border-right: ${borderRight};
    border-top: ${borderTop};
    border-radius: ${borderRadius};
  `;
};
exports.setBorders = setBorders;
const setFont = (props) => {
    const color = props.color;
    const fontFamily = props.fontFamily;
    const fontSize = props.fontSize;
    const fontStyle = props.fontStyle;
    const fontWeight = props.fontWeight;
    const lineHeight = props.lineHeight;
    const textDecoration = props.textDecoration;
    return (0, styled_components_1.css) `
    color: ${color};
    font-family: ${fontFamily};
    font-size: ${fontSize};
    font-style: ${fontStyle};
    font-weight: ${fontWeight};
    line-height: ${lineHeight};
    text-decoration: ${textDecoration};
  `;
};
const setSizing = (props) => {
    const height = props.height;
    const margin = props.margin;
    const padding = props.padding;
    const width = props.width;
    const minWidth = props.minWidth;
    const maxWidth = props.maxWidth;
    const minHeight = props.minHeight;
    const maxHeight = props.maxHeight;
    const gap = props.gap;
    return (0, styled_components_1.css) `
    height: ${height};
    margin: ${margin};
    padding: ${padding};
    width: ${width};
    min-width: ${minWidth};
    max-width: ${maxWidth};
    min-height: ${minHeight};
    max-height: ${maxHeight};
    gap: ${gap};
  `;
};
exports.setSizing = setSizing;
const setTextAlignment = (props) => {
    const textAlign = props.textAlign;
    const verticalAlign = props.verticalAlign;
    return (0, styled_components_1.css) `
    text-align: ${textAlign};
    vertical-align: ${verticalAlign};
  `;
};
const setBackgroundColor = (props) => {
    const backgroundColor = props.backgroundColor;
    return (0, styled_components_1.css) `
    background-color: ${backgroundColor};
  `;
};
exports.setBackgroundColor = setBackgroundColor;
exports.StyledBox = (0, styled_components_1.default)(box_1.Box) `
  ${exports.setBorders}
  ${setFont}
  ${exports.setSizing}
  ${setTextAlignment}
`;
exports.StyledContainer = (0, styled_components_1.default)(box_1.Container) `
  ${exports.setBorders}
  ${setFont}
  ${exports.setSizing}
  ${setTextAlignment}
  ${exports.setBackgroundColor}
`;
exports.StyledItem = (0, styled_components_1.default)(box_1.Item) `
  ${exports.setBorders}
  ${setFont}
  ${exports.setSizing}
  ${setTextAlignment}
`;
